import { validation, yupObject } from 'utils/validation';

const { token } = validation.tokenVerification;

export const validationSchema = yupObject({
  token,
});
